import Image from 'next/image'

export const CustomImageType = {
    TAG_IMAGE: 'TAG_IMAGE'
}
const CustomImage = ({ rowDisplay, smaller, cartItem, image, preview, productDetail }) => {
    function generateImage() {
        if (image)
            return (
                <Image
                    placeholder={'blur'}
                    blurDataURL={preview ? preview : image}
                    alt={image}
                    loading={'lazy'}
                    src={image}
                    layout={'fill'}
                    objectPosition={'center'}
                    objectFit={'cover'}
                />
            )
    }

    if (rowDisplay) {
        if (productDetail) {
            return (
                <div
                    className={
                        'h-full min-w-[130px] max-w-[130px] xs:min-w-[170px] xs:max-w-[170px] lg:min-w-[400px] lg:max-w-[400px] lg:h-[400px]   xl:min-w-[500px] xl:max-w-[500px] xl:h-[500px]   2xl:min-w-[600px] 2xl:max-w-[600px] 2xl:h-[600px] relative lg:rounded-2xl xl:rounded-3xl  2xl:rounded-[2rem] lg:overflow-hidden'
                    }
                >
                    {generateImage()}
                </div>
            )
        } else if (cartItem) {
            return (
                <div
                    className={
                        'h-full min-w-[130px] max-w-[130px] xs:min-w-[170px] xs:max-w-[170px] lg:h-auto lg:min-w-[80px] lg:max-w-[80px] lg:min-h-[80px] lg:max-h-[80px] relative rounded overflow-hidden'
                    }
                >
                    {generateImage()}
                </div>
            )
        } else {
            // Promo tag
            return (
                <div
                    className={
                        'h-full min-w-[130px] max-w-[130px] xs:min-w-[170px] xs:max-w-[170px] lg:min-w-[238px] lg:max-w-[238px]   xl:min-w-[298px] xl:max-w-[298px]   2xl:min-w-[358px] 2xl:max-w-[358px] relative'
                    }
                >
                    {generateImage()}
                </div>
            )
        }
    } else {
        //  Product
        if (!smaller) {
            return <div className={'w-full relative h-0 pb-[100%]'}>{generateImage()}</div>
        } else {
            //  Recipe tag
            return <div className={'w-full relative h-0 pb-[66.66%]'}>{generateImage()}</div>
        }
    }
}
export default CustomImage
